import * as Sentry from '@sentry/react';
import { Cookies } from 'react-cookie';
import { logout as logoutAPI } from '../api/userProfile';

/**
 * Handles the complete logout process including:
 * - Calling the logout API
 * - Removing user session cookies
 * - Clearing Sentry user context
 */
export const handleCompleteLogout = async (): Promise<void> => {
  const cookies = new Cookies();
  try {
    await logoutAPI();
  } catch (error) {
    Sentry.captureException(error);
  } finally {
    cookies.remove('user_session_token', { path: '/' });
    Sentry.setUser(null);
  }
};
